function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#4667ED",
  width: 20,
  height: 20,
  rx: 1.5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.353 2.353)",
  fill: "#F7F8FC"
}, /*#__PURE__*/React.createElement("rect", {
  x: 6.435,
  width: 2.252,
  height: 14.801,
  rx: 1.126
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.962 7.4c0 .622-.505 1.127-1.127 1.127H1.287a1.126 1.126 0 110-2.253h12.548c.622 0 1.127.504 1.127 1.126z"
})));

const SvgAddPlus = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add_plus.e235e76e.svg";
export { ForwardRef as ReactComponent };